// Helpers de gráficas del dashboard — infraestructura NUEVA [RGM] aprobada
// explícitamente por Rafael (el dashboard web no replica un proc GX; el GX no
// define colores de ejes de charts). Los ejes (ticks) usan GRIS MEDIO FIJO:
// legible en light Y dark. NO se lee --cui-body-color en runtime — el chart
// se monta UNA vez y no re-renderiza al cambiar el tema (el color leído en
// light quedaba NEGRO al activar dark después). Chart.js no resuelve var() en
// canvas; el gris medio funciona en ambos modos siempre.

/**
 * Color de los ejes: GRIS MEDIO FIJO (#8a93a2).
 */
export function colorEjes(): string {
  return '#8a93a2'
}

/**
 * Opciones comunes de escalas para CChart: ticks con el color del tema y
 * grilla gris neutra (visible en ambos modos).
 */
export function opcionesEjes() {
  const color = colorEjes()
  return {
    scales: {
      x: {
        grid: { color: 'rgba(128,128,128,0.25)', drawOnChartArea: false },
        // [RGM] 2026-10-03 (reporte Rafael: "la línea del lado de los valores
        // pinta a negro en dark"): el BORDE DEL EJE usaba el default de
        // Chart.js (negro al 10%) que no se adapta al tema — en dark quedaba
        // invisible. Mismo gris fijo de la grilla (las líneas de la grilla NO
        // se tocan).
        border: { display: true, color: 'rgba(128,128,128,0.25)' },
        ticks: { color },
      },
      y: {
        beginAtZero: true,
        grid: { color: 'rgba(128,128,128,0.25)' },
        border: { display: true, color: 'rgba(128,128,128,0.25)' },
        ticks: { color },
      },
    },
  }
}
